const STORAGE_KEY = "theme"

function getTheme() {
  return localStorage.getItem(STORAGE_KEY) || "system"
}

function applyTheme(theme) {
  const isDark =
    theme === "dark" ||
    (theme === "system" && window.matchMedia("(prefers-color-scheme: dark)").matches)

  document.documentElement.classList.toggle("dark", isDark)
  syncToggleButtons(theme)
}

function setTheme(theme) {
  localStorage.setItem(STORAGE_KEY, theme)
  applyTheme(theme)
}

function syncToggleButtons(theme) {
  document.querySelectorAll("[data-theme-toggle] [data-theme]").forEach((btn) => {
    if (btn.dataset.theme === theme) {
      btn.setAttribute("data-active", "")
    } else {
      btn.removeAttribute("data-active")
    }
  })
}

function initThemeToggles() {
  syncToggleButtons(getTheme())
  document.querySelectorAll("[data-theme-toggle] [data-theme]").forEach((btn) => {
    btn.addEventListener("click", () => setTheme(btn.dataset.theme))
  })
}

// Watch OS preference changes when in system mode
window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", () => {
  if (getTheme() === "system") applyTheme("system")
})

export { getTheme, setTheme, applyTheme, initThemeToggles }
